import { useContext, useEffect } from 'react';
import { useMapEvents } from 'react-leaflet';

import { PreferLocationContext } from '../../../../services/prefer-location/prefer-location.context';

// send request to geoapify
const fetchData = (mapEvent, setPlace, type, setFindLocationLoading) => {
  let zoomLevel = mapEvent.getZoom();
  const southWest = mapEvent.getBounds()._southWest;
  const northEast = mapEvent.getBounds()._northEast;
  const requestOptions = {
    method: 'GET',
  };

  if (zoomLevel > 9 && type) {
    setFindLocationLoading(true);
    fetch(
      `https://api.geoapify.com/v2/places?categories=catering.${type}&filter=rect:${southWest.lng},${southWest.lat},${northEast.lng},${northEast.lat}&limit=100&apiKey=29a1d2a03f754078ac6aa77f921dc442`,
      requestOptions
    )
      .then((response) => response.json())
      .then((res) => {
        setPlace(res.features);
        setFindLocationLoading(false);
      })
      .catch((error) => {
        console.log('error', error);
        setFindLocationLoading(false);
      });
  } else {
    setPlace(null);
  }
  return null;
};

export const GetPlaces = () => {
  const { type, setPlace, setFindLocationLoading } = useContext(PreferLocationContext);

  const mapEvent = useMapEvents({
    zoomanim() {
      fetchData(mapEvent, setPlace, type, setFindLocationLoading);
    },
    dragstart() {
      fetchData(mapEvent, setPlace, type, setFindLocationLoading);
    },
  });

  useEffect(() => {
    fetchData(mapEvent, setPlace, type, setFindLocationLoading);
  }, [type]);
  return null;
};
